<template>
    <el-dialog width="60%" :title="title" :visible.sync="viewDetail" @close="closeModel">
        <div v-loading="loading">
            <div id="main" ref="echarts" :style="{ width: '100%', height: '200px' }" v-if="xlist&&xlist.length>0"></div>
            <el-empty description="暂无内容" v-else></el-empty>
        </div>
    </el-dialog>
</template>

<script>
import { infoData, infoactiveData } from "@/api/erweima/index";
const echarts = require("echarts");
export default {
    props: {
        title: {
            type: String,
        },
    },
    data() {
        return {
            viewDetail: true,
            loading: false,
            xlist: [],
            ylist: [],
        };
    },
    mounted() {
        this.$nextTick(() => {
            if (this.title == "效果统计") {
                this.infoData_();
            } else {
                this.infoactiveData_();
            }
        });
    },
    methods: {
        closeModel() {
            this.$emit("closeModel");
        },
        drawChart() {
            let bar_dv = document.getElementById("main");
            var myEchart;
            if (myEchart != null && myEchart != "" && myEchart != undefined) {
                myEchart.dispose(); //销毁
            }
            myEchart = echarts.init(document.getElementById("main")); //初始化
            // let myEchart = this.$echarts.init(bar_dv);

            let option = {
                xAxis: {
                    type: "category",
                    data: this.xlist,
                    /*  data: this.timeData, */
                    splitLine: {
                        show: true,
                    },
                    axisTick: {
                        show: false,
                    },
                },
                yAxis: {
                    type: "value",
                    splitLine: {
                        show: true,
                    },
                },
                grid: {
                    show: true,
                    y2: 40,
                    top: "10%",
                    left: "14%",
                    right: "4%",
                    borrom: "0",
                },
                series: [
                    {
                        type: "line",
                        // smooth: true,
                        // symbol: "none",
                        data: this.ylist,
                        /* data: this.priceData */
                    },
                ],
            };
            myEchart.setOption(option);
            window.onresize = myEchart.resize();
        },
        //infoData
        infoData_() {
            this.loading = true;
            let par = {
                rebate_id: this.$getSessionStorage("rebate_id"),
            };
            infoData(par)
                .then((res) => {
                    this.loading = false;
                    if (res.code == 1) {
                        let list = res.data.list;
                        for (var key in list) {
                            this.ylist.push(list[key]);
                            this.xlist.push(key);
                        }
                        this.drawChart();
                    } else {
                        this.$message.error({ message: res.msg });
                    }
                })
                .catch((err) => {});
        },
        infoactiveData_() {
            this.loading = true;
            let par = {
                agent_id: this.$getSessionStorage("agent_id"),
            };
            infoactiveData(par)
                .then((res) => {
                    this.loading = false;
                    if (res.code == 1) {
                        let list = res.data.list;
                        for (var key in list) {
                            this.ylist.push(list[key]);
                            this.xlist.push(key);
                        }
                        this.drawChart();
                    } else {
                        this.$message.error({ message: res.msg });
                    }
                })
                .catch((err) => {});
        },
    },
    components: {},
};
</script>

<style scoped lang="scss">
</style>
